import React from "react";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Fleet from "./components/Fleet";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollProgress from "./components/ScrollProgress";

function App() {
  return (
    <LanguageProvider>
      <div className="App font-body bg-sky-50 text-slate-900 antialiased selection:bg-yellow-200 selection:text-slate-900">
        <ScrollProgress />
        <Header />
        <main>
          <Hero />
          <About />
          <Fleet />
          <Reviews />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
